import { render } from "./search.vue?vue&type=template&id=771f296d&lang=pug"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"

import "./search.vue?vue&type=style&index=0&id=771f296d&lang=scss"

import exportComponent from "../../../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__